import cart from '@/services/cart.service.ts';
import { compact } from 'lodash';
import { forEach } from 'lodash';
var state = {
    all: [],
    map: {},
};
var getters = {
    // TODO Get option by id
    option: function (state) { return function (id) {
        return state.map[id];
    }; },
    allOptions: function (state) {
        return state.all;
    },
    getChoicesForOption: function (state) { return function (optionId) {
        var option = state.map[optionId];
        if (!option) {
            return null;
        }
        return state.map[optionId].choices;
    }; },
    getChoiceStateForOption: function (state) { return function (id, optionId) {
        var choices = state.map[optionId].choices;
        var choiceIndex = choices.findIndex(function (choice) {
            return choice.id === id;
        });
        return (choiceIndex !== -1);
    }; },
    getChoiceQuantity: function (state) { return function (choice) {
        var option = state.map[choice.parentId];
        var storedChoice = cart.findChoiceInOption(option, choice);
        if (!storedChoice) {
            return '0';
        }
        return storedChoice.quantity;
    }; },
    getListedChoices: function (state) { return function (siblingId, _options) {
        var options = _options || state.all;
        var choices = options.map(function (option) {
            var listedChoices = [];
            var optionSibling = option.getChoicesForSibling(siblingId);
            optionSibling.forEach(function (choice) {
                var name = choice.configuredName();
                if (name !== '') {
                    var included = (choice.includedQuantity > choice.quantity);
                    var quantityDiff = choice.quantity - choice.includedQuantity;
                    var price = choice.price * quantityDiff;
                    var free = choice.freeChoice;
                    var listedChoice = {
                        id: choice.id,
                        name: name,
                        price: price,
                        quantity: choice.quantity,
                        included: included,
                        free: free,
                        parentId: option.id,
                    };
                    listedChoices.push(listedChoice);
                }
            });
            return listedChoices;
        });
        return compact(choices);
    }; },
    validOptions: function (state) {
        return cart.validateOptions(state.all);
    },
    allOptional: function (state) {
        return state.all.filter(function (option) {
            return !option.required;
        });
    },
    allRequired: function (state) {
        return state.all.filter(function (option) {
            return option.required;
        });
    },
    getSiblingOptionChoices: function (state) { return function (siblingId, _options) {
        var options = _options || state.all;
        return cart.siblingHasOptions(options, siblingId);
    }; },
    getSiblingOptions: function (state) { return function (siblingId, _options) {
        var options = _options || state.all;
        return cart.getSiblingOptions(options, siblingId);
    }; },
    getChoiceSibling: function (state) { return function (choice) {
        var option = state.map[choice.parentId];
        var optionChoice = cart.findChoiceInOption(option, choice);
        if (optionChoice === null) {
            return null;
        }
        if (optionChoice.quantity === 0) {
            return null;
        }
        return optionChoice.siblingId;
    }; }
};
var actions = {
    addOption: function (_a, option) {
        var commit = _a.commit;
        commit('addOption', option);
        commit('setOptionsFromMap');
    },
    setOptions: function (_a, options) {
        var commit = _a.commit;
        commit('setOptions', options);
    },
    clearOptions: function (_a) {
        var commit = _a.commit;
        commit('removeOptions');
    },
    setChoiceForOption: function (_a, _b) {
        var commit = _a.commit;
        var choice = _b.choice, option = _b.option;
        var optionId = (typeof option === 'object') ? option.id : option;
        commit('setChoiceForOption', {
            choice: choice,
            optionId: optionId,
        });
    },
    setChoiceQuantity: function (_a, _b) {
        var commit = _a.commit;
        var choice = _b.choice, quantity = _b.quantity;
        commit('setChoiceQuantity', {
            choice: choice,
            optionId: choice.parentId,
            quantity: quantity,
        });
    },
    setChoiceSibling: function (_a, _b) {
        var commit = _a.commit;
        var choice = _b.choice, siblingId = _b.siblingId;
        commit('setChoiceSibling', {
            choice: choice,
            optionId: choice.parentId,
            siblingId: siblingId,
        });
    },
    addChoice: function (_a, choice) {
        var commit = _a.commit;
        commit('addChoice', choice);
    },
    removeChoice: function (_a, choice) {
        var commit = _a.commit;
        commit('removeChoice', choice);
    },
    updateChoice: function (_a, choice) {
        var commit = _a.commit;
        commit('updateChoice', choice);
    }
};
var mutations = {
    addOption: function (state, option) {
        var cartOption = cart.prepareOption(option);
        state.map[cartOption.id] = cartOption;
    },
    removeOptions: function (state) {
        state.all = [];
        state.map = {};
    },
    setOptions: function (state, options) {
        var allOptions = cart.allOptionsFromMap(options);
        state.all = allOptions;
        state.map = {};
        forEach(state.all, function (option) {
            state.map[option.id] = option;
        });
    },
    setOptionsFromMap: function (state) {
        var allOptions = cart.allOptionsFromMap(state.map);
        state.all = allOptions;
    },
    setChoiceForOption: function (state, _a) {
        var choice = _a.choice, optionId = _a.optionId;
        var option = state.map[optionId];
        state.map[optionId] = cart.addChoiceToOption(option, choice);
    },
    setChoiceQuantity: function (state, _a) {
        var choice = _a.choice, optionId = _a.optionId, quantity = _a.quantity;
        var option = state.map[optionId];
        state.map[optionId] = cart.setChoiceQuantityForOption(option, choice, quantity);
    },
    setChoiceSibling: function (state, _a) {
        var choice = _a.choice, optionId = _a.optionId, siblingId = _a.siblingId;
        var option = state.map[optionId];
        state.map[optionId] = cart.setSiblingForChoice(option, choice, siblingId);
    },
    addChoice: function (state, _a) {
        var choice = _a.choice;
        var storedOption = state.map[choice.parentId];
        var option = cart.addChoiceToOption(storedOption, choice);
        state.map[option.id] = option;
    },
    removeChoice: function (state, choice) {
        var storedOption = state.map[choice.parentId];
        var option = cart.removeCartChoiceFromOption(storedOption, choice);
        state.map[option.id] = option;
    },
    updateChoice: function (state, choice) {
        var storedOption = state.map[choice.parentId];
        var option = cart.updateChoiceForOption(storedOption, choice);
        state.map[option.id] = option;
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/cart.option.store.ts
// module id = null
// module chunks = 